import { render } from "./ClassificationComponent.vue?vue&type=template&id=759db430"
import script from "./ClassificationComponent.vue?vue&type=script&lang=js"
export * from "./ClassificationComponent.vue?vue&type=script&lang=js"

import "./ClassificationComponent.vue?vue&type=style&index=0&id=759db430&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__